import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { Footer } from '../components/Footer';
import { ClockIcon, CoffeeIcon, SaladIcon, UtensilsCrossedIcon, SunIcon } from 'lucide-react';
const menuHighlights = [{
  icon: CoffeeIcon,
  title: 'Frühstück',
  desc: 'Starten Sie den Tag mit unserem reichhaltigen Frühstücksbuffet. Täglich 6:00 – 11:00 Uhr.',
  time: '06:00 – 11:00'
}, {
  icon: SunIcon,
  title: 'Mittagstisch',
  desc: 'Wechselnde Tagesgerichte, frisch zubereitet mit regionalen Zutaten.',
  time: '11:30 – 14:00'
}, {
  icon: UtensilsCrossedIcon,
  title: 'Abendkarte',
  desc: 'Genießen Sie unsere vielfältige Abendkarte mit Klassikern und saisonalen Spezialitäten.',
  time: '17:00 – 21:30'
}, {
  icon: SaladIcon,
  title: 'Snacks & Getränke',
  desc: 'Kleine Gerichte, Kuchen und Getränke – den ganzen Tag über verfügbar.',
  time: 'Durchgehend'
}];
const stagger = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function RestaurantPage() {
  return <>
      <PageHeader title="Auszeit Restaurant" subtitle="Die Auszeit, die Sie verdienen." image="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&q=80" accentColor="text-transparent bg-clip-text bg-gradient-to-r from-white to-gold" accentGlow="bg-gold" data-id="element-457" />

      <section className="py-20 px-4 bg-base" data-id="element-458">
        <div className="max-w-7xl mx-auto" data-id="element-459">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-3xl mb-20" data-id="element-460">
            <h2 className="text-4xl font-heading font-bold mb-6 text-gray-900" data-id="element-461">
              Frische Küche, die begeistert
            </h2>
            <p className="text-lg text-gray-500 leading-relaxed mb-6" data-id="element-462">
              Unser Auszeit Restaurant verbindet regionale Küche mit frischen
              Zutaten und einem Ambiente, das zum Verweilen einlädt. Ob
              herzhaftes Frühstück, schneller Mittagstisch oder gemütliches
              Abendessen – bei uns finden Sie für jeden Moment das Richtige.
            </p>
            <p className="text-lg text-gray-500 leading-relaxed" data-id="element-463">
              Unsere Köche bereiten täglich frische Gerichte zu, inspiriert von
              der fränkischen Tradition und modernen Einflüssen. Lassen Sie sich
              überraschen.
            </p>
          </motion.div>

          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{
          once: true
        }} className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-20" data-id="element-464">
            {menuHighlights.map(item => {
            const Icon = item.icon;
            return <motion.div key={item.title} variants={fadeUp} className="glass-card p-8 rounded-2xl border-gold/10" data-id="element-465">
                  <div className="flex items-center justify-between mb-5" data-id="element-466">
                    <div className="w-12 h-12 rounded-xl bg-gold/10 flex items-center justify-center" data-id="element-467">
                      <Icon className="w-6 h-6 text-gold" strokeWidth={1.5} data-id="element-468" />
                    </div>
                    <span className="text-gold/80 text-sm font-medium" data-id="element-469">
                      {item.time}
                    </span>
                  </div>
                  <h3 className="text-xl font-heading font-bold mb-2 text-gray-900" data-id="element-470">
                    {item.title}
                  </h3>
                  <p className="text-gray-500" data-id="element-471">{item.desc}</p>
                </motion.div>;
          })}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="glass-card p-8 rounded-2xl border-gold/20 max-w-xl" data-id="element-472">
            <div className="flex items-center gap-3 mb-4" data-id="element-473">
              <ClockIcon className="w-5 h-5 text-gold" data-id="element-474" />
              <h3 className="text-xl font-heading font-bold text-gray-900" data-id="element-475">
                Öffnungszeiten
              </h3>
            </div>
            <p className="text-gray-700 mb-2" data-id="element-476">
              Montag – Sonntag: 06:00 – 22:00 Uhr
            </p>
            <p className="text-gray-500 text-sm" data-id="element-477">
              Warme Küche durchgehend bis 21:30 Uhr
            </p>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-478" />
    </>;
}